/* eslint-disable camelcase */
/* eslint-disable max-classes-per-file */
import React, { ReactNode, useState } from 'react';
import { faEdit, faList, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Col } from 'react-bootstrap';

import ShadePriceBreakdown from './ShadeActions/ShadePriceBreakdown';
// import ShadeForm from '../ShadeForm/ShadeForm';

import ServiceAssembly from './ShadeActions/ServiceAssembly';
import Button from '../../Parts/Button';
import { deleteAssemblies, updateAssemblyNoPrice } from '../../Store/entities/assemblies/index';
import { useAssembliesByQuoteId, UseAssembly } from "../../Store/entities/assemblies/hooks";
import { useQuoteById, useQuoteTypeNameByQuoteId } from '../../Store/entities/quotes/hooks';
import { UsePortalDispatch } from '../../Store/index';
import { useIsEngineer, useIsSales, useIsService } from '../../Store/user/hooks';
import { useIsPsAdmin } from '../../hooks.js';
import ShadeSummary from './ShadeSummaryNew';
import EditPSOutdoorShadeModal from '../../Modals/ShadeModals/EditShade/EditPSOutdoorShade/EditPSOutdoorShadeModal';
import { fakeRootType } from '../../FakeRootType.js';
import SingleEditIndoor from '../../Modals/ShadeModals/EditShade/EditIndoorShade/SingleEditIndoor';
import { QuoteTypeNames } from '../../powershadesApiTypes';
import ShadeDuplicate from './ShadeDuplicate';
import EditCOROutdoorShadeModal from '../../Modals/ShadeModals/EditShade/EditCOROutdoorShade/EditCOROutdoorShadeModal';
import { useQuoteAccessories } from '../../Store/entities/accessories/hooks';
import { deleteQuoteAccessory } from '../../Store/entities/accessories';
import { loadHwItemsByQuoteId } from '../../Store/entities/hardwareRequestItems';

type ShadeActionsProps = {
	quoteId: number;
	sequenceId: number;
	ROOT: fakeRootType;
};

const ShadeActions = ({ quoteId, sequenceId, ROOT }: ShadeActionsProps) => {
	const quote = useQuoteById(quoteId);

	const quoteAccessories = useQuoteAccessories(quoteId);

	const quoteAssemblies = useAssembliesByQuoteId(quoteId);

	const dispatch = UsePortalDispatch();

	const assembly = UseAssembly(quoteId, sequenceId);

	const buttons = [] as ReactNode[];

	// const shade = this.props.quoteData.shadeSubstitute(sequenceId);
	const {
		editable,
		previous_quote_id
	} = quote;

	const quoteType = useQuoteTypeNameByQuoteId(quoteId);

	const [shadeFormOpen, setShadeFormOpen] = useState(false);
	const [shadePriceBreakdownOpen, setShadePriceBreakdownOpen] = useState(false);

	// const closeEditModel = () => {
	// 	quoteData.UI.reRenderTable(true);
	// 	setShadeFormOpen(false);
	// }

	const userIsPsAdmin = useIsPsAdmin();

	const isEngineer = useIsEngineer();
	const isService = useIsService();
	const isSales = useIsSales();
	const userHasServiceAccess = isEngineer || isService || isSales;
	if (!quote) return null;
	if (!assembly) return null;
	const { shade_name: shadeName } = assembly;
	const {
		toast,
		alert
	} = ROOT;

	// const onDuplicate = () => {
	// 	const maxSeqId = Math.max(...assys.map((a) => a.sequence_id));

	// 	const nameSet = assembly?.shade_name?.toString()?.split(" ") ?? "";

	// 	let number = nameSet[nameSet.length - 1] ?? "";

	// 	let newName = assembly.shade_name;

	// 	if (isNaN(Number(number)) || number === "") {
	// 		number = "1";
	// 		nameSet.push(number);
	// 	}
	// 	let newNumber = parseInt(number) + 1;

	// 	const shadeNames
	// 		= assys.map((sa) => sa?.shade_name?.toString().trim()) ?? "";

	// 	nameSet[nameSet.length - 1] = `${newNumber}`;

	// 	newName = nameSet.join(" ");

	// 	while (shadeNames.includes(newName.trim())) {
	// 		nameSet[nameSet.length - 1] = `${++newNumber}`;
	// 		newName = nameSet.join(" ");
	// 	}

	// 	dispatch(duplicateAssembly({
	// 		quoteId: quoteId,
	// 		sequenceId: sequenceId,
	// 		inputs: {
	// 			new_shade_name: `${newName}`,
	// 			requested_new_sequence_id: maxSeqId + 1,
	// 		}
	// 	})).then(() => {
	// 		toast(`${shadeName} duplicated`, {
	// 			type: 'success',
	// 		});
	// 	}).catch(() => {
	// 		toast(`Duplication of ${shadeName} failed`, {
	// 			type: 'info',
	// 		});
	// 	});

	// }

	const onDelete = () => {
		alert({
			title: 'Are you sure you want to delete this shade?',
			text: `You are about to delete ${shadeName}! There's no way to undo this.`,
			icon: 'warning',
			quoteType,
		})
			.then(() => {
				const outdoorShades = quoteAssemblies?.filter((a) =>
					a.shade_type_id === 2 || a.shade_type_id === 3) || [];

				const isLastOutdoorShade = outdoorShades.length === 1 && outdoorShades[0]?.sequence_id === sequenceId;

				const deletePromises: any[] = [
					dispatch(deleteAssemblies({
						quoteId,
						sequenceIds: [sequenceId],
					})).then(() => {
						//reload Hardware items
						dispatch(loadHwItemsByQuoteId(quoteId));
					})
				];

				if (isLastOutdoorShade) {
					const accessoriesToDelete = quoteAccessories.filter((a) =>
						a.accessory_id === 239 || a.part_number === "PS_AC_WHIP_2023_BK");
					accessoriesToDelete.map((accessory) => deletePromises.push(dispatch(deleteQuoteAccessory({
						quoteId,
						lineNumber: accessory.line_number
					}))));
				}

				Promise.all(deletePromises)
					.then(() => {
						const message = isLastOutdoorShade
							? `${shadeName} deleted and related accessories removed`
							: `${shadeName} deleted`;
						toast(message, {
							type: 'success',
						});
					})
					.catch(() => {
						toast(`Deletion of ${shadeName} failed`, {
							type: 'info',
						});
					});
			})
			.catch(() => {
				toast(`Deletion of ${shadeName} canceled`, {
					type: 'info',
				});
			});
	};

	if (editable) {
		if (assembly?.shade_type_id === 3) {
			buttons.push(<Col>
				{shadeFormOpen && <EditPSOutdoorShadeModal
					isOpen={shadeFormOpen}
					onClose={() => setShadeFormOpen(false)}
					quoteId={quoteId}
					sequenceId={assembly.sequence_id}
				/>}
				<Button
					title="Edit"
					size="sm"
					hoverColor={quoteType}
					fullWidth
					color="light"
					onClick={() => setShadeFormOpen(true)}
				>
					<FontAwesomeIcon icon={faEdit} />
				</Button>
			</Col>);
		} else if (assembly?.shade_type_id === 2) {
			buttons.push(<Col>
				{shadeFormOpen && <EditCOROutdoorShadeModal
					isOpen={shadeFormOpen}
					onClose={() => setShadeFormOpen(false)}
					quoteId={quoteId}
					sequenceId={assembly.sequence_id}
				/>}
				<Button
					title="Edit"
					size="sm"
					hoverColor={quoteType}
					fullWidth
					color="light"
					onClick={() => setShadeFormOpen(true)}
				>
					<FontAwesomeIcon icon={faEdit} />
				</Button>
			</Col>);
		} else {
			buttons.push(<Col>
				{shadeFormOpen && <SingleEditIndoor
					key={`edit-indoor-shade-modal-${sequenceId}`}
					isOpen={shadeFormOpen}
					onClose={() => setShadeFormOpen(false)}
					quoteId={quoteId}
					sequenceId={assembly.sequence_id}
				/>}
				<Button
					title="Edit"
					size="sm"
					hoverColor={quoteType}
					fullWidth
					color="light"
					onClick={() => setShadeFormOpen(true)}
				>
					<FontAwesomeIcon icon={faEdit} />
				</Button>
			</Col>);
		}

		buttons.push(<Col>
			<ShadeDuplicate
				quoteId={quoteId}
				sequenceId={sequenceId}
			/>

		</Col>);

		buttons.push(<Col>
			<Button
				fullWidth
				color="light"
				size="sm"
				hoverColor={quoteType}
				key="delete"
				title="Delete"
				onClick={onDelete}
			>
				<FontAwesomeIcon icon={faTrashAlt} />
			</Button>
		</Col>);
	}

	buttons.push(<ShadeSummary
		quoteId={quoteId}
		sequenceId={sequenceId}
	/>);
	// Add ShadeSummary
	// Add PriceBreakdown
	if (userIsPsAdmin) {
		buttons.push(<Col>
			<Button
				fullWidth
				color="light"
				size="sm"
				title="Price Breakdown"
				hoverColor={quoteType}
				onClick={() => setShadePriceBreakdownOpen(true)}
				className=""
			>
				<FontAwesomeIcon icon={faList} />
			</Button>
			{shadePriceBreakdownOpen && <ShadePriceBreakdown
				sequenceId={sequenceId}
				quoteId={quoteId}
				// Old Object
				done={() => setShadePriceBreakdownOpen(false)}
				close={() => setShadePriceBreakdownOpen(false)}
				open={shadePriceBreakdownOpen}
			/>}
		</Col>);
	}

	if (userHasServiceAccess) {
		buttons.push(<ServiceAssembly
			// SetShadeToBeMadeFunction={(value, row, column) =>
			// quoteData.SetShadeToBeMade(sequenceId, value, row, column)}
			// SetFabricToBeCut={(value) => quoteData.SetFabricToBeCut(sequenceId, value)}
			// SetHeaderExtrusionToBeCut={(value) =>
			// 	quoteData.SetHeaderExtrusionToBeCut(sequenceId, value)
			// }
			// SetHembarToBeCut={(value) => quoteData.SetHembarToBeCut(sequenceId, value)}
			// SetSideChannelsToBeCut={(value) => quoteData.SetSideChannelsToBeCut(sequenceId, value)}
			// SetSillChannelsToBeCut={(value) => quoteData.SetSillChannelsToBeCut(sequenceId, value)}
			// SetTubeToBeCut={(value) => quoteData.SetTubeToBeCut(sequenceId, value)}
			quoteType={quoteType as QuoteTypeNames}
			key={`${sequenceId}-service-assembly`}
			// assembly={shade.data() as unknown as AssemblyShadePayload}
			// SetIsMotorOnly={(value) => quoteData.SetIsMotorOnly(sequenceId, value)}
			// SetIsChannelsOnly={(value) => quoteData.SetIsChannelsOnly(sequenceId, value)}
			SetRecipeSku={(value) => dispatch(updateAssemblyNoPrice(quoteId, sequenceId, (a) => {
				// eslint-disable-next-line no-param-reassign
				a.recipe_sku = value;
				return a;
			}))}
			// SetIsTubeAndFabricOnly={(value) => quoteData.SetIsTubeAndFabricOnly(sequenceId, value)}
			// SetIsHeaderExtrusionOnly={(value) =>
			// 	quoteData.SetIsHeaderExtrusionOnly(sequenceId, value)
			// }
			// SetIsHardwareOnly={(value) => quoteData.SetIsHardwareOnly(sequenceId, value)}
			// SetIsShadeService={(value) => quoteData.SetIsShadeService(sequenceId, value)}
			// SetTubeOverride={(value) => quoteData.SetTubeOverride(sequenceId, value)}
			// SetMotorOverride={(value) => quoteData.SetMotorOverride(sequenceId, value)}
			// SetIsCrownAndDriveOnly={(value) => quoteData.SetIsCrownAndDriveOnly(sequenceId, value)}
			previousQuoteId={previous_quote_id ?? 0}
			sequenceId={sequenceId}
			quoteId={quoteId}
		/>);
	}
	return (
		<div className="justify-content-between g-0" style={{ columnCount: 2, columnGap: 0 }}>{buttons}</div>
	);
};

export default ShadeActions;
